// import React from "react";
// import styled from "styled-components";
// // Components
// import ClientSlider from "../Elements/ClientSlider";
// import ServiceBox from "../Elements/ServiceBox";
// import FullButton from "../Buttons/FullButton";
// // Assets
// import AddImage1 from "../../assets/img/add/1.png";
// import AddImage2 from "../../assets/img/add/2.png";
// import AddImage3 from "../../assets/img/add/3.png";
// import AddImage4 from "../../assets/img/add/4.png";

// export default function Services() {
//   return (
//     <Wrapper id="services">
//       <div className="lightBg" style={{ padding: "50px 0" }}>
//         <div className="container">
//           <ClientSlider />
//         </div>
//       </div>
//       <div className="whiteBg" style={{ padding: "60px 0" }}>
//         <div className="container">
//           <HeaderInfo>
//             <h1 className="font40 extraBold">Social Media</h1>
//             <p className="font13">
//               Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam
//               nonumy eirmod tempor invidunt ut
//               <br />
//               labore et dolore magna aliquyam erat, sed diam voluptua.
//             </p>
//           </HeaderInfo>
//           <ServiceBoxRow className="flex">
//             <ServiceBoxWrapper>
//               <ServiceBox
//                 icon="roller"
//                 title="Graphic Design"
//                 subtitle="Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua."
//               />
//             </ServiceBoxWrapper>
//             <ServiceBoxWrapper>
//               <ServiceBox
//                 icon="monitor"
//                 title="Web Design"
//                 subtitle="Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore."
//               />
//             </ServiceBoxWrapper>
//             <ServiceBoxWrapper>
//               <ServiceBox
//                 icon="browser"
//                 title="Development"
//                 subtitle="Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat."
//               />
//             </ServiceBoxWrapper>
//             <ServiceBoxWrapper>
//               <ServiceBox
//                 icon="printer"
//                 title="Print"
//                 subtitle="Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor."
//               />
//             </ServiceBoxWrapper>
//           </ServiceBoxRow>
//         </div>
//         <div className="lightBg">
//           <div className="container">
//             <Advertising className="flexSpaceCenter">
//               <AddLeft>
//                 <h4 className="font15 semiBold">A few words about company</h4>
//                 <h2 className="font40 extraBold">A Study of Creativity</h2>
//                 <p className="font12">
//                   Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed
//                   diam nonumy eirmod tempor invidunt ut labore et dolore magna
//                   aliquyam erat, sed diam voluptua. At vero eos et accusam et
//                   justo duo dolores et ea rebum.
//                 </p>
//                 <ButtonsRow
//                   className="flexNullCenter"
//                   style={{ margin: "30px 0" }}
//                 >
//                   <div style={{ width: "190px" }}>
//                     <FullButton
//                       title="Get Started"
//                       action={() => alert("clicked")}
//                     />
//                   </div>
//                   <div style={{ width: "190px", marginLeft: "15px" }}>
//                     <FullButton
//                       title="Contact Us"
//                       action={() => alert("clicked")}
//                       border
//                     />
//                   </div>
//                 </ButtonsRow>
//               </AddLeft>
//               <AddRight>
//                 <AddRightInner>
//                   <div className="flexNullCenter">
//                     <AddImgWrapp1 className="flexCenter">
//                       <img src={AddImage1} alt="office" />
//                     </AddImgWrapp1>
//                     <AddImgWrapp2>
//                       <img src={AddImage2} alt="office" />
//                     </AddImgWrapp2>
//                   </div>
//                   <div className="flexNullCenter">
//                     <AddImgWrapp3>
//                       <img src={AddImage3} alt="office" />
//                     </AddImgWrapp3>
//                     <AddImgWrapp4>
//                       <img src={AddImage4} alt="office" />
//                     </AddImgWrapp4>
//                   </div>
//                 </AddRightInner>
//               </AddRight>
//             </Advertising>
//           </div>
//         </div>
//       </div>
//     </Wrapper>
//   );
// }

// const Wrapper = styled.section`
//   width: 100%;
// `;
// const ServiceBoxRow = styled.div`
//   @media (max-width: 860px) {
//     flex-direction: column;
//   }
// `;
// const ServiceBoxWrapper = styled.div`
//   width: 20%;
//   margin-right: 5%;
//   padding: 80px 0;
//   @media (max-width: 860px) {
//     width: 100%;
//     text-align: center;
//     padding: 40px 0;
//   }
// `;
// const HeaderInfo = styled.div`
//   @media (max-width: 860px) {
//     text-align: center;
//   }
// `;
// const Advertising = styled.div`
//   margin: 80px 0;
//   padding: 100px 0;
//   position: relative;
//   @media (max-width: 1160px) {
//     padding: 100px 0 40px 0;
//   }
//   @media (max-width: 860px) {
//     flex-direction: column;
//     padding: 0 0 30px 0;
//     margin: 80px 0 0px 0;
//   }
// `;
// const ButtonsRow = styled.div`
//   @media (max-width: 860px) {
//     justify-content: space-between;
//   }
// `;
// const AddLeft = styled.div`
//   width: 50%;
//   p {
//     max-width: 475px;
//   }
//   @media (max-width: 860px) {
//     width: 80%;
//     order: 2;
//     text-align: center;
//     h2 {
//       line-height: 3rem;
//       margin: 15px 0;
//     }
//     p {
//       margin: 0 auto;
//     }
//   }
// `;
// const AddRight = styled.div`
//   width: 50%;
//   position: absolute;
//   top: -70px;
//   right: 0;
//   @media (max-width: 860px) {
//     width: 80%;
//     position: relative;
//     order: 1;
//     top: -40px;
//   }
// `;
// const AddRightInner = styled.div`
//   width: 100%;
// `;
// const AddImgWrapp1 = styled.div`
//   width: 48%;
//   margin: 0 6% 10px 6%;
//   img {
//     width: 100%;
//     height: auto;
//     border-radius: 1rem;
//     box-shadow: 0 2px 15px rgba(0, 0, 0, 0.3);
//     -webkit-box-shadow: 0 2px 15px rgba(0, 0, 0, 0.3);
//     -moz-box-shadow: 0 2px 15px rgba(0, 0, 0, 0.3);
//   }
// `;
// const AddImgWrapp2 = styled.div`
//   width: 30%;
//   margin: 0 5% 10px 5%;
//   img {
//     width: 100%;
//     height: auto;
//     border-radius: 1rem;
//     box-shadow: 0 2px 15px rgba(0, 0, 0, 0.3);
//     -webkit-box-shadow: 0 2px 15px rgba(0, 0, 0, 0.3);
//     -moz-box-shadow: 0 2px 15px rgba(0, 0, 0, 0.3);
//   }
// `;
// const AddImgWrapp3 = styled.div`
//   width: 20%;
//   margin-left: 40%;
//   img {
//     width: 100%;
//     height: auto;
//     border-radius: 1rem;
//     box-shadow: 0 2px 15px rgba(0, 0, 0, 0.3);
//     -webkit-box-shadow: 0 2px 15px rgba(0, 0, 0, 0.3);
//     -moz-box-shadow: 0 2px 15px rgba(0, 0, 0, 0.3);
//   }
// `;
// const AddImgWrapp4 = styled.div`
//   width: 30%;
//   margin: 0 5%auto;
//   img {
//     width: 100%;
//     height: auto;
//     border-radius: 1rem;
//     box-shadow: 0 2px 15px rgba(0, 0, 0, 0.3);
//     -webkit-box-shadow: 0 2px 15px rgba(0, 0, 0, 0.3);
//     -moz-box-shadow: 0 2px 15px rgba(0, 0, 0, 0.3);
//   }
// `;
import React from "react";
import styled from "styled-components";

const socialFeeds = [
  {
    platform: "Instagram",
    icon: "📸",
    posts: [
      "https://www.instagram.com/reel/Cuy44_NLVIw/",
      "https://www.instagram.com/p/CnungEyJoOc/",
      "https://www.instagram.com/p/DLASO9nsQ3C/",
    ],
  },
  {
    platform: "Facebook",
    icon: "📘",
    posts: [
      "https://www.facebook.com/watch/?v=695441000044494",
      "https://www.facebook.com/bintjbeil.org/videos/745112894531759",
      "https://www.facebook.com/bintjbeil.org/posts/pfbid0DaENp5UtkQSBDNCP1wuQEEKSLU1KNYJTtdCfkXZvKsGDRGRFpd5xRqMS5T2a7fUul",
    ],
  },
  {
    platform: "TikTok",
    icon: "🎵",
    posts: [
      "https://www.tiktok.com/@xovo51/video/7515723922915003666?is_from_webapp=1&sender_device=pc",
      "https://www.tiktok.com/@lifetime.series48/video/7501122497920634154?is_from_webapp=1&sender_device=pc",
      "https://www.tiktok.com/@lvo__/video/7515856849875340551?is_from_webapp=1&sender_device=pc",
    ],
  },
];

const SocialFeedCard = ({ platform, icon, posts }) => (
  <Card>
    <h3>
      {icon} {platform}
    </h3>
    <ScrollArea>
      {posts.map((url, i) => {
        const cleanUrl = url.replace(/\/$/, "");

        // Instagram Embed
        if (platform === "Instagram") {
          const embedUrl = cleanUrl.includes("/reel/")
            ? cleanUrl.replace("/reel/", "/p/") + "/embed"
            : cleanUrl + "/embed";

          return (
            <PostPreview key={i}>
              <iframe
                src={embedUrl}
                width="100%"
                height="500"
                frameBorder="0"
                scrolling="no"
                allowTransparency="true"
                allow="encrypted-media"
                title={`Instagram Post ${i + 1}`}
              ></iframe>
            </PostPreview>
          );
        }

        // Facebook Embed
        if (platform === "Facebook") {
          return (
            <PostPreview key={i}>
              <iframe
                src={`https://www.facebook.com/plugins/post.php?href=${encodeURIComponent(
                  url
                )}&show_text=true&width=500`}
                width="100%"
                height="500"
                style={{ border: "none", overflow: "hidden" }}
                scrolling="no"
                frameBorder="0"
                allowFullScreen={true}
                allow="autoplay; clipboard-write; encrypted-media; picture-in-picture; web-share"
                title={`Facebook Post ${i + 1}`}
              ></iframe>
            </PostPreview>
          );
        }

        // TikTok Embed
        if (platform === "TikTok") {
          const videoIdMatch = url.match(/\/video\/(\d+)/);
          const videoId = videoIdMatch ? videoIdMatch[1] : null;

          if (!videoId) return null;

          return (
            <PostPreview key={i}>
              <iframe
                src={`https://www.tiktok.com/embed/${videoId}`}
                width="100%"
                height="600"
                frameBorder="0"
                allow="autoplay; encrypted-media"
                title={`TikTok Video ${i + 1}`}
              ></iframe>
            </PostPreview>
          );
        }

        return null;
      })}
    </ScrollArea>
  </Card>
);

export default function Services() {
  return (
    <Wrapper id="services">
      <div className="whiteBg" style={{ padding: "60px 0" }}>
        <div className="container">
          <HeaderInfo>
            <h1 className="font40 extraBold">Social Media Feed</h1>
            <p className="font13">
              Static preview of recent posts from Instagram, Facebook, and
              TikTok.
            </p>
          </HeaderInfo>
          <FeedRow className="flex">
            {socialFeeds.map((feed, idx) => (
              <FeedWrapper key={idx}>
                <SocialFeedCard {...feed} />
              </FeedWrapper>
            ))}
          </FeedRow>
        </div>
      </div>
    </Wrapper>
  );
}

// Styled Components
const Wrapper = styled.section`
  width: 100%;
`;

const HeaderInfo = styled.div`
  text-align: center;
`;

const FeedRow = styled.div`
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
`;

const FeedWrapper = styled.div`
  width: 30%;
  margin: 15px;
  @media (max-width: 860px) {
    width: 90%;
  }
`;

const Card = styled.div`
  background: #fff;
  border-radius: 1rem;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.1);
  padding: 20px;
  height: 400px;
  overflow: hidden;
`;

const ScrollArea = styled.div`
  overflow-y: auto;
  max-height: 320px;
  margin-top: 15px;
  padding-right: 5px;

  &::-webkit-scrollbar {
    width: 6px;
  }
  &::-webkit-scrollbar-thumb {
    background: #ccc;
    border-radius: 3px;
  }
`;

const PostPreview = styled.div`
  margin-bottom: 15px;
  iframe {
    width: 100%;
    border-radius: 8px;
  }
`;
